import React, { useState, useEffect, useCallback } from 'react';
import './admin.css';
import { Link } from 'react-router-dom';

const Admin = () => {
  const [filters, setFilters] = useState({
    username: '',
    userRole: '',
    employeeName: '',
    status: ''
  });

  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchUsers = useCallback(async () => {
    const queryParams = new URLSearchParams({
      ...filters,
      page: currentPage,
      limit: 10
    }).toString();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}users?${queryParams}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("jwt")
        }
      });
      const data = await response.json();

      if (response.ok) {
        setUsers(data.users || []);
        setTotalPages(Math.ceil(data.total / 10));
      } else {
        alert('Error: ' + data.error);
      }
    } catch (err) {
      console.error('Error:', err);
      alert('An error occurred while fetching the users');
    }
  }, [filters, currentPage]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchUsers();
  };

  const handleReset = () => {
    setFilters({
      username: '',
      userRole: '',
      employeeName: '',
      status: ''
    });
    setCurrentPage(1);
    fetchUsers();
  };

  const handleDelete = async (userId) => {
    const confirmDelete = window.confirm("Do you want to delete this user?");
    if (!confirmDelete) {
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}users/${userId}`, {
        method: 'DELETE',
        headers: {
          Authorization: "Bearer " + localStorage.getItem("jwt")
        }
      });

      if (response.ok) {
        fetchUsers();
      } else {
        const data = await response.json();
        alert('Error: ' + data.error);
      }
    } catch (err) {
      console.error('Error:', err);
      alert('An error occurred while deleting the user');
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <div className='admin-panel'>
      <div className="admin-filters">
        <input 
          type="text"  
          placeholder="Search Username" 
          name="username" 
          value={filters.username} 
          onChange={handleInputChange} 
        />
        <select name="userRole" value={filters.userRole} onChange={handleInputChange}>
          <option value="">Select Role</option>
          <option value="user">User</option>
          <option value="administrator">Administrator</option>
        </select>
        <input 
          type="text" 
          placeholder="Employee Name" 
          name="employeeName" 
          value={filters.employeeName} 
          onChange={handleInputChange} 
        />
        <select name="status" value={filters.status} onChange={handleInputChange}>
          <option value="">Select Status</option>
          <option value="Enabled">Enabled</option>
          <option value="Disabled">Disabled</option>
        </select>
        <button className="filter-btn-reset" onClick={handleReset}>Reset</button>
        <button className="filter-btn-search" onClick={handleSearch}>Search</button>
      </div>

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Role</th>
              <th>Employee Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(users) && users.length > 0 ? (
              users.map((user) => (
                <tr key={user._id}>
                  <td>{user.FirstName}</td>
                  <td>{user.Role}</td>
                  <td>{`${user.FirstName} ${user.LastName}`}</td>
                  <td>{user.status}</td>
                  <td>
                    <Link to={`/edit-user/${user._id}`}><button className="admin-btn-edit">Edit</button></Link>
                    <button className="admin-btn-delete" onClick={() => handleDelete(user._id)}>Delete</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No users found</td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="admin-pagination">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
            <button
              key={page}
              onClick={() => handlePageChange(page)}
              className={page === currentPage ? 'pagination-active' : 'pagination-btn'}
            >
              {page}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Admin;
